import { combineReducers } from "redux";
import { globalChatReducer } from "./globalChat/reducer";
import { memoriesReducer } from "./memories/reducer";
import { State } from "./state";
import { userReducer } from "./user/reducer";

const appReducer = combineReducers({
  user: userReducer,
  memories: memoriesReducer,
  globalChat: globalChatReducer,
});

export const rootReducer = (state: State | undefined, action: any) => {
  if (action.type === "CLEAR_REDUX_STATE") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
